import React from 'react';

const BibleIcon: React.FC<{ fill: string }> = ({ fill = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="Religion-Bible--Streamline-Ultimate"
    height="24"
    width="24"
  >
    <desc>Religion Bible Streamline Icon: https://streamlinehq.com</desc>
    <path
      d="M19.75 4V2a2 2 0 0 0 -2 -2H5.25a3 3 0 0 0 -3 3v18a3 3 0 0 0 3 3h14.5a2 2 0 0 0 2 -2V6a2 2 0 0 0 -2 -2Zm-11 9a0.51 0.51 0 0 1 -0.5 -0.5v-1a0.51 0.51 0 0 1 0.5 -0.5h2a0.5 0.5 0 0 0 0.5 -0.5v-2a0.51 0.51 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0.5 0.5v2a0.5 0.5 0 0 0 0.5 0.5h2a0.5 0.5 0 0 1 0.5 0.5v1a0.5 0.5 0 0 1 -0.5 0.5h-2a0.5 0.5 0 0 0 -0.5 0.5v5a0.5 0.5 0 0 1 -0.5 0.5h-1a0.51 0.51 0 0 1 -0.5 -0.5v-5a0.5 0.5 0 0 0 -0.5 -0.5ZM5.25 2h12a0.5 0.5 0 0 1 0.5 0.5v1a0.5 0.5 0 0 1 -0.5 0.5h-12a1 1 0 0 1 0 -2Z"
      fill={fill}
      strokeWidth="1"
    />
  </svg>
);

export default BibleIcon;
